export enum EPageType {
  ACCOUNT_DELETION = 'account-deletion',

  REPORT_INFRINGEMENT = 'infringement',

  LEGAL_POLICY = 'policy',
  LEGAL_UNAVAILABLE = 'legal_unavailable',

  EMAIL_UNSUBSCRIBE = 'email-unsubscribe',
  EMAIL_PREFERENCE = 'email-preference',
}
